<template>
  <div class="score-wrap">
    <div class="score">
      <div class="score-content">
        <span>Your data accuracy score:</span>
        <van-tag class="ml-1" size="medium" round type="primary"> {{userDataIntegrityData.integrity}} </van-tag>
      </div>
    </div>
    <div class="score">
      <div class="score-content">
        <span>Your consumption today:</span>
        <van-tag class="ml-1" round size="medium" type="primary">{{ userDataIntegrityData.nowSeconds}}</van-tag>
        <van-tag class="ml-1" round size="medium" type="primary">{{ userDataIntegrityData.nowSecondsPercentage}}</van-tag>
      </div>

    </div>
    <div class="score">
      <div class="score-content">
        <span>Your consumption yesterday:</span>
        <van-tag class="ml-1" round size="medium" type="primary">{{ userDataIntegrityData.yesterdaySeconds}}</van-tag>
        <van-tag class="ml-1" round size="medium" type="primary">{{ userDataIntegrityData.yesterdaySecondsPercentage}}</van-tag>
      </div>

    </div>
    <div class="score">
      <div class="score-content">
        <span>Your average consumption last week:</span>
        <van-tag class="ml-1" round size="medium" type="primary">{{ userDataIntegrityData.weekSeconds}}</van-tag>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashTapinGoal",
  props: {
    userDataIntegrityData: {
      type: Object,
      default: {}
    }
  }
}
</script>

<style scoped lang="less">
.score-wrap {
  margin-top:10px;
  background: #222222;
  font-size:14px;
  padding:12px;
  & >  * + *  {
    margin-top:10px;
  }
}
</style>
